<script setup lang="ts">
  import { onMounted, computed, ref } from 'vue'
  import { useRoute } from 'vue-router'
  import ClientActionService from '../services/clientaction.service'
  import CompletedFeedback from '../components/voiceBotFeedback/completedFeedback.vue' // Assuming CompletedFeedback is another component
  import type { AxiosResponse } from 'axios'
  import Client404 from '../components/404/404.vue'
  import FeedbackForm from '../components/voiceBotFeedback/feedbackForm.vue'
  import { genericErrorToast } from '@/lib/toasts'

  const route = useRoute()
  const voiceShortId = computed(() => route.params.id as string | undefined)
  const currentFeedback = ref<any>(null)
  const loadingFeedback = ref<boolean>(false)
  const requestFailed = ref<boolean>(false)

  onMounted(() => {
    if (!voiceShortId.value) {
      return
    }

    loadingFeedback.value = true
    ClientActionService.retrieveVoiceBotFeedback(voiceShortId.value)
      .then((response: AxiosResponse<any>) => {
        currentFeedback.value = response.data
      })
      .catch((error: any) => {
        requestFailed.value = true
        genericErrorToast()
        console.error(error)
      })
      .finally(() => {
        loadingFeedback.value = false
      })
  })

  const feedbackSubmitted = () => {
    currentFeedback.value.is_submitted = true
  }
</script>

<template>
  <Client404 v-if="!voiceShortId || requestFailed" />
  <div v-else-if="loadingFeedback">Loading...</div>
  <CompletedFeedback v-else-if="currentFeedback && currentFeedback.is_submitted" />
  <div
    v-else-if="currentFeedback !== null"
    class="centered-container"
  >
    <FeedbackForm
      class="feedback-form"
      :feedbackId="currentFeedback.uuid"
      @feedback-submitted="feedbackSubmitted"
    />
  </div>
</template>

<style scoped>
  .centered-container {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 100vh;
    padding: 1rem;
    box-sizing: border-box;
  }

  .feedback-form {
    width: 100%;
    max-width: 600px;
    box-sizing: border-box;
    padding: 1rem;
  }

  @media (min-width: 768px) {
    .feedback-form {
      width: 33.33%;
    }
  }
</style>
